import React from 'react';

export default function Pagination({ page, perPage, setPage, totalCount }) {
  console.log(page,perPage,setPage,totalCount)
    const start =totalCount === 0 ? 0 : (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, totalCount || 0);
  return (
    <div>
      {' '}
      <a
        href="#"
        className="previous round"
         onClick={(e) => {
          e.preventDefault();
          if (page > 1) setPage(page - 1);
        }}
      >
        &#8249;
      </a>
           &nbsp; {start} - {end} of {totalCount || 0} &nbsp;
      {/* {Math.min(page * perPage, totalCount)} of {totalCount} &nbsp; */}
      <a
        href="#"
        className="next round"
        onClick={(e) => {
          e.preventDefault();
          if (end < totalCount) setPage(page + 1);
        }}
      >
        &#8250;
      </a>
    </div>
  );
}
